import Select from '../base/Select'
import ContentTips from './ContentTips'
import { formatText, elementToText } from '../utils/richText'
import './TodoTable.css'
import React from 'react'

function TableColumAttr({ showVisibility }) {
    return (
        <colgroup>
            <col width="150" />
            {showVisibility && <col width="90" />}
            <col width="60" />
            <col width="90" />
            <col width="450" />
        </colgroup>
    )
}

function TableHeader({ editable, showVisibility }) {
    return (
        <thead className="ne-tr">
            <tr>
                <td className="ne-td ne-td-middle" rowSpan="3" data-col="0">项目</td>
                {showVisibility && (
                    <td className="ne-td ne-td-middle ne-td-select" rowSpan="3" data-col="1">公开</td>
                )}
                <td className="ne-td ne-td-middle ne-td-select" rowSpan="3" data-col="2">时间</td>
                <td className="ne-td ne-td-middle ne-td-select" rowSpan="3" data-col="3">优先级</td>
                <td className="ne-td ne-td-middle" data-col="4">
                    内容
                    <ContentTips editable={editable} />
                </td>
            </tr>
        </thead>
    )
}

// 条目级公开开关：默认可见，选“仅自见”时该条目不会出现在个人主页等公开页面
function VisibilitySelect({ value = true, onChange }) {
    return (
        <select
            className="ne-visibility"
            defaultValue={value === false ? '0' : '1'}
            onChange={onChange}
        >
            <option value="1">可见</option>
            <option value="0">仅自见</option>
        </select>
    )
}

function ItemList({ item, inputMethod, showVisibility }) {
    const handlePaste = (e) => {
        e.preventDefault()

        const html = e.clipboardData?.getData('text/html') || ''
        let text = ''

        if (html) {
            const tempDiv = document.createElement('div')
            tempDiv.innerHTML = html
            text = elementToText(tempDiv)
        }

        if (!text) {
            text = e.clipboardData?.getData('text/plain') || ''
        }

        if (!text) {
            return
        }

        const formattedHtml = formatText(text)
        const target = e.currentTarget

        const isInitialEmpty = target.innerHTML === '<ne-p><br></ne-p>' ||
                               target.innerHTML === '<ne-p><br/></ne-p>' ||
                               target.textContent.trim() === ''

        const selection = window.getSelection()

        if (isInitialEmpty) {
            target.innerHTML = formattedHtml
        } else if (selection && selection.rangeCount > 0) {
            const range = selection.getRangeAt(0)
            range.deleteContents()

            const tempDiv = document.createElement('div')
            tempDiv.innerHTML = formattedHtml

            const fragment = document.createDocumentFragment()
            let node
            while ((node = tempDiv.firstChild)) {
                fragment.appendChild(node)
            }

            range.insertNode(fragment)
            range.collapse(false)
            selection.removeAllRanges()
            selection.addRange(range)
        }

        if (inputMethod) {
            inputMethod()
        }
    }

    return (
        <tbody className="ne-table-inner">
            <tr className="ne-tr">
                <td
                    className="ne-td ne-td-middle ne-edit"
                    rowSpan="3"
                    suppressContentEditableWarning={true}
                    contentEditable={true}
                    data-col="0"
                    onPaste={handlePaste}
                    dangerouslySetInnerHTML={{ __html: formatText(item?.project || '') }}
                />
                {showVisibility && (
                    <td className="ne-td ne-td-middle ne-td-select" rowSpan="3" data-col="1">
                        {inputMethod
                            ? <VisibilitySelect value={item?.is_public !== false} onChange={inputMethod} />
                            : (item?.is_public === false ? '仅自见' : '可见')}
                    </td>
                )}
                <td
                    className="ne-td ne-td-middle ne-edit ne-td-select"
                    rowSpan="3"
                    suppressContentEditableWarning={true}
                    contentEditable={true}
                    data-col="2"
                    onPaste={handlePaste}
                    dangerouslySetInnerHTML={{ __html: formatText(item?.time || '') }}
                />
                <td className="ne-td ne-td-middle ne-td-select" rowSpan="3" data-col="3">
                    <Select name="score" defaultValue={item?.score || 0} onChange={inputMethod} />
                </td>
                <td
                    className="ne-td ne-edit"
                    suppressContentEditableWarning={true}
                    contentEditable={true}
                    data-col="4"
                    data-placeholder="要做的事..."
                    onPaste={handlePaste}
                    dangerouslySetInnerHTML={{ __html: item?.extra?.plan ? formatText(item.extra.plan) : '' }}
                />
            </tr>
            <tr className="ne-tr">
                <td
                    className="ne-td ne-edit"
                    suppressContentEditableWarning={true}
                    contentEditable={true}
                    data-col="4"
                    data-placeholder="完成情况..."
                    onPaste={handlePaste}
                    dangerouslySetInnerHTML={{ __html: item?.extra?.done ? formatText(item.extra.done) : '' }}
                />
            </tr>
            <tr className="ne-tr">
                <td
                    className="ne-td ne-edit"
                    suppressContentEditableWarning={true}
                    contentEditable={true}
                    data-col="4"
                    data-placeholder="个人总结..."
                    onPaste={handlePaste}
                    dangerouslySetInnerHTML={{ __html: item?.extra?.summary ? formatText(item.extra.summary) : '' }}
                />
            </tr>
        </tbody>
    )
}

// showVisibility：他人主页看到的都是已公开条目，展示这一列没有意义，故默认对访客隐藏
function TodoTable({ items = [], inputMethod, showVisibility = true }) {
    const displayItems = items.length > 0 ? items : [{ id: 1 }]
    // 只有编辑页会传 inputMethod，详情页是只读的，不需要看编辑相关的技巧
    const editable = Boolean(inputMethod)

    return (
        <ne-table-box onInput={inputMethod}>
            <table className="ne-table">
                <TableColumAttr showVisibility={showVisibility} />
                <TableHeader editable={editable} showVisibility={showVisibility} />
                {displayItems.map((item, index) => (
                    <ItemList
                        key={item.id || index}
                        item={item}
                        inputMethod={inputMethod}
                        showVisibility={showVisibility}
                    />
                ))}
            </table>
        </ne-table-box>
    )
}

export default TodoTable
